import { render, staticRenderFns } from "./FabShareButton.vue?vue&type=template&id=2235fd98&"
import script from "./FabShareButton.vue?vue&type=script&lang=js&"
export * from "./FabShareButton.vue?vue&type=script&lang=js&"
import style0 from "./FabShareButton.vue?vue&type=style&index=0&id=2235fd98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports